export default __webpack_public_path__ + "static/media/Messages.d52ebdb9.svg";